
export class SportsListModel {
  id: string;
  name: string;
  constructor( obj: {
    Id_Deporte: string;
    Des_Deporte: string;
  } ) {
  //   if ( !obj ) { return; }

    this.id = obj && obj.Id_Deporte ? obj.Id_Deporte : '';
    this.name = obj && obj.Des_Deporte ? obj.Des_Deporte : '';
  }
}
